// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "annotation-app" + "." + "d6a5b38fc87266992d5f" + ".js";
};